import { render, staticRenderFns } from "./CreanceIndex.vue?vue&type=template&id=06f2107d&"
import script from "./CreanceIndex.vue?vue&type=script&lang=js&"
export * from "./CreanceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f2107d')) {
      api.createRecord('06f2107d', component.options)
    } else {
      api.reload('06f2107d', component.options)
    }
    module.hot.accept("./CreanceIndex.vue?vue&type=template&id=06f2107d&", function () {
      api.rerender('06f2107d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vente-creance/creances/CreanceIndex.vue"
export default component.exports